import Axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import http from './http';
import { serialize } from '../utils/common';
import router from './router';

let axiosIns: AxiosInstance = Axios.create();
let _header: any = {};
let _params: any = {};
axiosIns.interceptors.request.use((config: AxiosRequestConfig): AxiosRequestConfig => {
	config.data = serialize(config.data || {});
	config.url = config.url || '';
	config.headers = Object.assign({}, _header, config.headers);

	if (config.method && /^get$/i.test(config.method)) {
		//get模式下将data参数转换成queryString;
		config.url =
			config.url +
			(config.url.indexOf('?') >= 0 ? '&' : '?') +
			Object.entries(config.data)
				.map(item => {
					return `${item[0]}=${item[1]}`;
				})
				.join('&');
		//如果没有参数.去掉queryString末尾的?/&号无用字符;
		config.url = config.url.replace(/(\&|\?)$/g, '');
	}
	config.withCredentials = true;
	return config;
});

let axiosHandlerFn: any = null;
axiosIns.interceptors.response.use(
	(response: AxiosResponse): any => {
		let resData: any = {
			code: response.data.code || response.data.status || response.data.errCode,
			msg: response.data.msg || response.data.message || response.data.errMsg,
			data: response.data.data,
		};

		axiosHandlerFn && axiosHandlerFn.call(router.app, resData);
		//执行通用回调函数;

		//http网络状态为200, 接口返回状态为200, 执行正常逻辑;
		if (response.status == 200 && resData.code == 200) {
			//接口调用成功, 返回接口数据;
			//重点: 按{error, success}格式返回数据;
			return { success: resData };
		}
		//http状态不为200或接口返回{error}数据到then处理器;
		return { error: resData };
	},
	(error: any) => {
		axiosHandlerFn && axiosHandlerFn.call(router.app, { msg: error.message });
		//出现错误时也返回{error}数据到then处理器;
		return { error: { msg: error.message } };
	},
	//说明: 关于返回值. 目前async/await只能用try/catch捕获错误, 而try/catch有严重性能和准确度缺陷.
	//		所以使用另一种思路, 将所有请求结果都认为是正确的并返回给到then处理器, 这样不会造成await异常结束.
	//		在await处使用{error, success}解构获取到返回值, 再根据error/success是否为undefined判断请求结果;
	//参考:	https://segmentfault.com/a/1190000017718513
);

/**
 * 全局统一管理的API调用方法
 * @param api 要请求的API别称, 如"USER_INFO";
 * @param params 附带的参数对象, 根据请求类型会自动序列化
 */
export function request (api: string, params: any = {}, headers: any = {}){
	const apiEntity = http[api];
	if (apiEntity) {
		if (!/\S/.test(apiEntity.api)) {
			throw new Error('接口地址为空, 请检查并修正此问题!');
		}
		if (!/^(get|post|option|put|patch|delete|head)$/i.test(apiEntity.method)) {
			apiEntity.method = 'get';
		}
		return axiosIns.request({
			url: apiEntity.api,
			method: apiEntity.method,
			data: Object.assign({}, _params, params),
			headers: Object.assign({}, _header, headers),
		});
	} else {
		throw new Error('无效的API请求: ' + api);
	}
}

export function setHeader (key: string, value: any){
	_header[key] = value;
}
export function setParam (key: string, value: any){
	_params[key] = value;
}

export function setHandler (callback: any){
	axiosHandlerFn = callback;
}
export default axiosIns;
